module.exports = __webpack_public_path__ + "img/governance-banner3.1e9651fd.png";